import { produce } from 'immer';

export const putActiveStep = produce((draft, { formId, updateStep }) => {
  draft[formId].inProgress = true;
  draft[formId].activeStep = updateStep;
});
